/**
 * Iter XX.265 — Design preview for `AuthedHomeHero`.
 *
 * A tiny debug route (`/preview/home-hero`) so we can visually verify
 * the new authenticated-home hero on iPhone (390×844) and Android
 * (412×915) viewports without needing a live authenticated session.
 *
 * Not linked from anywhere in the product. Safe to leave — pure
 * dev/QA surface.
 */
import React, { useRef, useState } from "react";
import AuthedHomeHero from "../components/AuthedHomeHero";

const FAKE_USER = {
  name: "Rohan Sharma",
  first_name: "Rohan",
  email: "rohan@example.com",
};

export default function AuthedHomeHeroPreview() {
  const composerRef = useRef(null);
  const [pinned, setPinned] = useState(true);
  // Iter XX.268 — allow a "mission attached" preview at
  // `/preview/home-hero?mission=1` so the founder can visually
  // verify the CurrentMissionCard positioning without needing a
  // real authenticated player with an active mission.
  const previewMission = React.useMemo(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      if (params.get("mission") !== "1") return null;
      return {
        mission_id: "msn_preview01",
        focus_area: "batting",
        focus_text:
          "Make your stride shorter, land with a soft front knee, and hold your shape at contact for one second.",
        focus_state: "active",
        source: "chat_inline",
      };
    } catch { return null; }
  }, []);
  return (
    <div className="min-h-screen bg-neutral-950 text-neutral-100 flex flex-col">
      <div className="flex-1 overflow-y-auto pb-40">
        <AuthedHomeHero
          user={FAKE_USER}
          showBackToConversation={pinned}
          onBackToConversation={() => setPinned(false)}
          onPrimaryTap={() => {
            try { composerRef.current?.focus(); } catch {}
            // eslint-disable-next-line no-console
            console.log("[preview] primary Gully card tapped");
          }}
          onStarterTap={(id, meta) => {
            // eslint-disable-next-line no-console
            console.log("[preview] starter tapped", id, meta);
          }}
          onVideoTap={() => {
            // eslint-disable-next-line no-console
            console.log("[preview] video card tapped");
          }}
          continueHint={{
            title: "You were working on staying tall through release.",
            subtitle: "From your last practice",
            message: "Let's continue on staying tall through release.",
          }}
          onContinueTap={(hint) => {
            // eslint-disable-next-line no-console
            console.log("[preview] continue tapped", hint);
          }}
          activeMission={previewMission}
          onMissionTriedTap={(missionId, focusText) => {
            // eslint-disable-next-line no-console
            console.log("[preview] mission tried it", missionId, focusText);
          }}
        />
      </div>
      {/* Fake composer so we can visualise thumb clearance. */}
      <div className="fixed inset-x-0 bottom-0 border-t border-neutral-800 bg-neutral-950/95 backdrop-blur px-3 py-3 pb-[env(safe-area-inset-bottom)]">
        <div className="max-w-2xl mx-auto flex items-center gap-2">
          <input
            ref={composerRef}
            className="flex-1 bg-neutral-900 border border-neutral-800 rounded-full px-4 py-3 text-sm text-neutral-100 placeholder:text-neutral-500 focus:outline-none focus:border-emerald-500"
            placeholder="Type your message…"
          />
          <button className="px-4 py-3 rounded-full bg-emerald-500 text-neutral-950 text-sm font-semibold">
            Send
          </button>
        </div>
      </div>
    </div>
  );
}
